import React from "react";
import { motion } from "framer-motion";

const tiers = [
  {
    n: "I",
    name: "Assembly",
    scope: "State-level legislative campaigns",
    points: [
      "Booth-level micro-targeting",
      "Candidate narrative & media training",
      "Rally choreography & turnout ops",
    ],
  },
  {
    n: "II",
    name: "Local Body",
    scope: "Panchayat · Municipal · Corporation",
    points: [
      "Ward-by-ward sentiment mapping",
      "Hyper-local content engines",
      "On-ground volunteer co-ordination",
    ],
  },
  {
    n: "III",
    name: "National",
    scope: "Lok Sabha · State Apparatus",
    points: [
      "National narrative architecture",
      "Multi-state media synchronisation",
      "War-room intelligence stack",
    ],
  },
];

const Elections = () => {
  return (
    <section
      id="elections"
      data-testid="elections-section"
      className="section-gutter py-20 md:py-32 border-t border-black/10"
    >
      <div className="grid grid-cols-12 gap-6 mb-12 md:mb-16">
        <div className="col-span-12 md:col-span-7">
          <div className="overline text-black/60">Chapter 06 — Election Practice</div>
          <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl mt-6 leading-[0.92]">
            Three tiers. <em>One discipline.</em>
          </h2>
        </div>
        <div className="col-span-12 md:col-span-4 md:col-start-9 self-end">
          <p className="text-sm md:text-base text-black/70">
            From village panchayats to the national stage — the playbook scales, the rigour doesn&apos;t bend.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-4 md:gap-0 border border-black">
        {tiers.map((t, i) => (
          <motion.div
            key={t.name}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 * i }}
            data-testid={`tier-${i}`}
            className={`col-span-12 md:col-span-4 p-8 md:p-10 ${
              i < tiers.length - 1 ? "md:border-r border-black" : ""
            } border-b md:border-b-0 border-black/20`}
          >
            <div className="flex items-baseline justify-between">
              <span className="font-serif-display italic text-5xl text-black/30">{t.n}</span>
              <span className="overline text-black/60">{t.scope}</span>
            </div>
            <h3 className="font-serif-display text-4xl md:text-5xl mt-6">{t.name}</h3>
            <ul className="mt-8 space-y-3">
              {t.points.map((p, k) => (
                <li
                  key={k}
                  className="text-sm md:text-base text-black/75 flex gap-3 leading-relaxed"
                >
                  <span className="mt-2 inline-block w-1.5 h-1.5 bg-black shrink-0" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Elections;
